import { connect } from 'react-redux'
import { selectReplyDraft } from 'ducks/drafts'
import NewEmailPage from './view'
import { withQueryParamsHandling } from './withQueryParamsHandling'

const select = state => ({
  draft: selectReplyDraft(state),
})

const View = withQueryParamsHandling(NewEmailPage)

export default connect(select)(View)
